import CloseIcon from '@components/icons/Close';

export default function CloseButton({ onHide }: { onHide?: any }) {
  return (
    <button onClick={onHide} className="modalButton" data-bs-dismiss="modal">
      <CloseIcon />
    </button>
  );
}
